/* eslint-disable @typescript-eslint/no-namespace */
import { Series, BasicSeries } from '../../types/deal.types';
import { Moment } from 'moment';
import { isSeriesEnhanced, isSeriesInsured } from '../issue/ratings';

export namespace DealSeries {
  export function erpValueGetter({ data: { series } }) {
    if (series) {
      return series.reduce((acc, ea) => {
        const seriesStatus = erpGetterForSeries(ea);
        if (acc.indexOf(seriesStatus) === -1) {
          acc.push(seriesStatus);
        }
        return acc;
      }, []);
    } else {
      return [];
    }
  }

  export function erpGetterForSeries(series): string {
    return series.isExtraordinaryCall;
  }

  export function getFirstCouponDateForSeries(series: Series[]): Moment[] {
    return extractDateField(series, 'firstCouponDate');
  }

  export function getDatedDateForSeries(series: Series[]): Moment[] {
    return extractDateField(series, 'datedDate');
  }

  export function getDeliveryDateForSeries(series: Series[]): Moment[] {
    return extractDateField(series, 'deliveryDate');
  }

  export function getDeliveryDateWithForwardIndForSeries(
    series: Series[]
  ): { date: Moment; forwardInd: boolean }[] {
    return series.reduce(
      (acc: { date: Moment; forwardInd: boolean }[], s: Series) => {
        const dateValue = s.deliveryDate || null;
        const forwardIndValue = s.forwardInd || false;
        const existing = acc.find(
          ({ date }: { date: Moment; forwardInd: boolean }) => {
            if (date === null) {
              return dateValue === null;
            }

            return date.isSame(dateValue, 'day');
          }
        );
        if (!existing) {
          acc.push({ date: dateValue, forwardInd: forwardIndValue });
        } else {
          existing.forwardInd = existing.forwardInd || forwardIndValue;
        }
        return acc;
      },
      []
    );
  }

  export function getAwardDateForSeries(series: Series[]): Moment[] {
    return extractDateField(series, 'awardDate');
  }

  export function getTradeDateForSeries(series: Series[]): Moment[] {
    return extractDateField(series, 'initialTradeDate');
  }
  export function getDistinctSeriesSecurityTypes(series: Series) {
    return Array.from(new Set(series.securityTypes));
  }

  export function isNotRated(series: BasicSeries, underlyingView: boolean) {
    let ratings = series.ratings;
    if (underlyingView) {
      ratings =
        isSeriesInsured(series) || isSeriesEnhanced(series)
          ? series.underlyingRatings
          : series.ratings;
    }

    return ratings.filter((r) => r.rating !== 'NR').length === 0;
  }

  export function extractDateField(series: Series[], fieldName: string) {
    return series.reduce((acc: Moment[], s: Series) => {
      const fieldValue = s[fieldName] || null;
      if (
        acc.find((date: Moment) => {
          return date === null
            ? date === fieldValue
            : date.isSame(fieldValue, 'day');
        }) === undefined
      ) {
        acc.push(fieldValue);
      }
      return acc;
    }, []);
  }
}
